import { apiService } from "../services/axios";
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { translateCategoryCodeToFrench, CATEGORY_CODE_TRANSLATIONS, ARRAN_WAR_CATEGORY_CODE } from '../utils/categoryTranslations';

const CategoryList = ({ shareToken }) => {
    const [data, setData] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        apiService.getPublic('/api/categories')
            .then((response) => {
                setData(response.data)
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    const handleCategoryClick = (categoryCode) => {
        if (shareToken) {
            // Navigation pour les pages partagées
            if (categoryCode === null) {
                // Retourner à l'URL de base sans le code de catégorie
                const currentPath = location.pathname;
                // Trouver la partie "la-collection-de-" et enlever tout ce qui suit
                const collectionIndex = currentPath.indexOf('/la-collection-de-');
                if (collectionIndex !== -1) {
                    const basePath = currentPath.substring(0, collectionIndex + '/la-collection-de-'.length);
                    // Extraire le nom du propriétaire depuis l'URL actuelle
                    const remainingPath = currentPath.substring(collectionIndex + '/la-collection-de-'.length);
                    const ownerName = remainingPath.split('/')[0];
                    navigate(`${basePath}${ownerName}`);
                } else {
                    navigate(`/partager/${shareToken}`);
                }
            } else {
                const frenchCode = translateCategoryCodeToFrench(categoryCode);
                // Construire l'URL avec le code de catégorie après "la-collection-de-"
                const currentPath = location.pathname;
                const collectionIndex = currentPath.indexOf('/la-collection-de-');
                if (collectionIndex !== -1) {
                    const basePath = currentPath.substring(0, collectionIndex + '/la-collection-de-'.length);
                    const remainingPath = currentPath.substring(collectionIndex + '/la-collection-de-'.length);
                    const ownerName = remainingPath.split('/')[0];
                    navigate(`${basePath}${ownerName}/${frenchCode}`);
                } else {
                    // Si on n'a pas encore la structure complète, on ne peut pas naviguer
                    console.warn('Structure d\'URL de partage non reconnue');
                }
            }
        } else {
            // Navigation pour les pages personnelles
            if (categoryCode === null) {
                navigate('/ma-collection');
            } else {
                const frenchCode = translateCategoryCodeToFrench(categoryCode);
                navigate(`/ma-collection/${frenchCode}`);
            }
        }
    };

    const isActiveCategory = (categoryCode) => {
        if (shareToken) {
            // Logique pour les pages partagées
            if (categoryCode === null) {
                // Le bouton "Tous" est actif si l'URL ne se termine pas par un code de catégorie français
                const currentPath = location.pathname;
                const collectionIndex = currentPath.indexOf('/la-collection-de-');
                if (collectionIndex !== -1) {
                    const remainingPath = currentPath.substring(collectionIndex + '/la-collection-de-'.length);
                    const segments = remainingPath.split('/');
                    const lastSegment = segments[segments.length - 1];
                    const frenchCodes = Object.values(CATEGORY_CODE_TRANSLATIONS);
                    return !frenchCodes.includes(lastSegment);
                }
                return true; // Par défaut, "Tous" est actif
            } else {
                const frenchCode = translateCategoryCodeToFrench(categoryCode);
                return location.pathname.endsWith(`/${frenchCode}`);
            }
        } else {
            // Logique pour les pages personnelles
            if (categoryCode === null) {
                return location.pathname === '/ma-collection';
            } else {
                const frenchCode = translateCategoryCodeToFrench(categoryCode);
                return location.pathname === `/ma-collection/${frenchCode}`;
            }
        }
    };

    const categoryButtons = data.flatMap((category) =>
        category.code === ARRAN_WAR_CATEGORY_CODE
            ? [
                { code: category.code, name: category.name },
                { code: 'arran-wars-crossover', name: "Guerres d'Arran (crossover)" }
            ]
            : [{ code: category.code, name: category.name }]
    );

    return (
        <div className="block buttons are-medium">
            <button 
                className={`button ${isActiveCategory(null) ? 'is-dark' : ''}`}
                onClick={() => handleCategoryClick(null)}
            >
                Tous
            </button>
            {categoryButtons.map((item) => (
                <button 
                    className={`button ${isActiveCategory(item.code) ? 'is-dark' : ''}`}
                    key={item.code}
                    onClick={() => handleCategoryClick(item.code)}
                >
                    {item.name}
                </button>
            ))}
        </div>
    );
}

export default CategoryList;
